export class Information {

  public recommandation: string;
  public objectifPrincipal: string;
  public email: string;
  public commentaire: string;
}



// WEBPACK FOOTER //
// ./src/app/information.ts